<div class="review-topbar box-shadow" [class.show]="show">

  <div class="container">

    <div class="row mt-2 mb-2 align-items-center justify-content-between">
      <div class="col">
        <a routerLink="/projects/{{ project?.Id }}" class="link-arrow left">{{ texts.toProject | localize }}</a>
      </div>

      <div class="col-auto">

        <button *ngIf="!isInCommentMode" class="btn btn-round btn-secondary btn-yellow me-2" (click)="addComment()">
          <i class="fa-sharp fa-regular fa-comment-middle me-2"></i> {{ texts.addNote | localize }}
        </button>

        <button *ngIf="isInCommentMode" class="btn btn-round btn-dark me-2" (click)="abortComment()">
          {{ texts.addNote | localize }} <i class="fa-sharp fa-solid fa-circle-xmark ms-2"></i>
        </button>

        <button *ngIf="project?.Status == 'AwaitingOrder'" class="btn btn-round btn-dark me-2" (click)="startModal.show(project, 'comment')">
          {{ texts.startSourcing | localize }} <i class="fa-sharp fa-solid fa-arrow-right ms-2"></i>
        </button>
      </div>

    </div>

  </div>
</div>

<app-jobsite-comment *ngFor="let c of comments" (delete)="deleteComment(c)" (close)="closeComment(c)" (reopen)="reopenComment(c)" [project]="project" [comment]="c" [isManager]="project.IsManager" [accessSecret]="accessSecret" [style.left]="c.X + '%'" [style.top]="c.Y +'%'"></app-jobsite-comment>

<app-modal-start-project #startModal [language]="loc.language"></app-modal-start-project>